import { DataService } from './dataService'
export const retailerService = {

    addRetailer: async (data) => {
        return DataService.post('/admin/add_retailer', data)
    },
    addGuestRetailer: async (data) => {
        return DataService.post('/admin/add_guest_retailer', data)
    },

    getRetailer: async (data) => {
        return DataService.get('/admin/get_retailer', data)
    },

    getRetailerDetails: async (data) => {
        return DataService.get('/admin/get_retailer_details', data)
    },
    getRetailerInvoices: async (data) => {
        return DataService.get('/admin/get_retailer_invoice_by_job', data)
    },
    
    updateRetailer: async (data) => {
        return DataService.post('/admin/update_retailer', data)
    },
    updateRetailerStatus: async (data) => {
        return DataService.post('/admin/update_retailer_status', data)
    },
    check_store_email: async(data) => {
        return DataService.post('/retailer/check_store_email',data)
    },
    getStoreData: async (data) => {
        return DataService.get('/admin/get_store', data)
    },
    searchRetailer: async (data) => {
        return DataService.get('/admin/search_retailer', data)
    },
    getAllRetailer: async (data) => {
        return DataService.get('/admin/get_all_retailer', data)
    },
    checkRefferalTokenApi: async (data) => {
        return DataService.post('/admin/check_retailer_token', data)
    },
    checkRefferalTokenApiRetailer: async (data) => {
        return DataService.post('/admin/check_retailer_token_for_retailer', data)
    },
    getRefferelRetailerData: async (data) => {
        return DataService.post('/admin/check_promocode_foruser', data)
    },
    deleteRetailerJob: async (data) => {
        return DataService.post('/admin/remove_guest_retailer', data)
    },
    getRetailerDutyTax: async (data) => {
        return DataService.get('/admin/retailer-duty-tax/get_all', data)
    },
    importRetailerDutyTax: async (data) => {
        return DataService.post('/admin/retailer-duty-tax/import', data)
    },
    exportRetailerDutyTax: async (data) => {
        return DataService.get('/admin/retailer-duty-tax/export', data)
    },
    deleteRetailer: async (data) => {
        return DataService.post('/admin/delete_retailer', data)
    },
    
}

